import { createSelector } from "reselect";
import getProject from "./get_project";

const getOrganizationIdForCurrentProject = createSelector([
  getProject
], (project) => project?.firebaseOrganizationId || null);

export default getOrganizationIdForCurrentProject
